export default function redirect(to) {
  if (window.location.search.indexOf('noredirect') === -1) {
    window.location.replace(to);
  } else {
    console.log(`Would have redirected to ${to}`); // eslint-disable-line no-console
  }
}